import { useEcoReports } from "./hooks/useEcoReports";
import { LiveCommentsTab } from "./components/LiveCommentsTab";
import { EcosTab } from "./components/EcosTab";
import React from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import { useLivesReports } from "./hooks/useLivesReports";

const Reports = () => {
  const [tab, setTab] = React.useState("liveComments");
  const eco = useEcoReports({ enabled: tab === "ecos" });
  const live = useLivesReports({ enabled: tab === "liveComments" });

  React.useEffect(() => {
    // siempre cierro dialogs
    live.setSelected(null);
    eco.setSelected(null);

    if (tab === "ecos") {
      eco.resetPage();
      eco.fetchNow?.();
    } else {
      live.resetPage();
      live.fetchNow?.();
    }
  }, [tab]);


  return (
    <Box p={2}>
      <Typography variant="h5" fontWeight={700} mb={1}>
        Reportes
      </Typography>

      <Paper variant="outlined" sx={{ mb: 2 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ px: 1 }}>
          <Tab value="liveComments" label="Comentarios de la librería" />
          <Tab value="ecos" label="Ecos" />
        </Tabs>
      </Paper>

      {tab === "liveComments" ? (
        <LiveCommentsTab live={live} />
      ) : (
        <EcosTab eco={eco} />
      )}
    </Box>
  );
};

export default Reports;
